module.exports = __webpack_public_path__ + "img/filter-no-results.d7cfa6e4.svg";